<template>
  <v-container fluid>
    <div class="text-left" v-show="!dialog">
      <v-btn
        class="secondary lighten-1 ml-n4 mt-n11"
        style="text-transform: none"
        @click="menu(true)"
        large
        rounded
      >
        <v-icon color="primary darken-1" left size="30px">mdi-menu-open</v-icon>
        <span class="title-map primary--text text--darken-1" color=""
          >Mostrar camadas</span
        >
      </v-btn>
    </div>
    <v-row v-show="dialog">
      <v-col
        :cols="isFullscreen ? '12' : '5'"
        :class="isFullscreen ? 'fullscreen-first-col' : 'first-col'"
      >
        <v-btn
          class="elevation-8 ml-n4 mt-n8"
          color="#242a35"
          style="text-transform: none; position: absolute; z-index: 6"
          @click="menu(false)"
          large
          rounded
        >
          <v-icon color="secondary lighten-1" left size="30px"
            >mdi-menu-open</v-icon
          >
          <span
            class="title-map secondary--text text--lighten-1"
            color="primary"
            >Recolher camadas</span
          >
        </v-btn>
        <v-card class="primary darken-1 pa-0 mt-2 elevation-0">
          <v-card-subtitle class="mb-1" v-show="basin">
            <h4
              class="mb-6 white--text"
              style="
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 16px;
                line-height: 20px;
              "
            >
              Bacia selecionada:
            </h4>
            <div style="display: flex">
              <div>
                <v-icon
                  class="mr-2"
                  color="white"
                  size="16"
                  :style="`height: 24px; width: 24px; border-radius: 50%;background-color: ${basinIconColor};`"
                  >{{ basinIconName }}</v-icon
                >
              </div>
              <div>
                <strong
                  class="white--text"
                  style="
                    font-family: Roboto;
                    font-style: normal;
                    font-weight: bold;
                    font-size: 16px;
                    line-height: 20px;
                  "
                >
                  {{ basinName }}
                </strong>
              </div>
            </div>
          </v-card-subtitle>
          <v-card-text class="pt-1">
            <strong class="select-layer-text white--text"
              >Selecione a camada para visualizar no mapa</strong
            >
            <div
              class="group-layers mt-6"
              v-for="(group, index) in overlaysGroup"
              :key="index"
            >
              <left-group-layer-map-menu
                :group="group"
                :locations="locations"
                :satellites="satellites"
                @changeEnabledGroupLayer="changeEnabledGroupLayer($event)"
                @changeTimeFeature="changeTimeFeature($event)"
                @changeEnabledSublayer="changeEnabledSublayer($event)"
                @changeOpacitySublayer="changeOpacitySublayer($event)"
                @changeCurrentSatelliteState="
                  changeCurrentSatelliteState($event)
                "
              ></left-group-layer-map-menu>
            </div>
            <new-base-layers-map-menu
              class="mt-3"
              :baseLayers="baseLayers"
              :initialBaseLayer="getVisbleBaseLayer()"
              @changeBaseLayer="setAttributionLayer($event)"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        :cols="isFullscreen ? '12' : '7'"
        :class="isFullscreen ? 'fullscreen-second-col' : 'second-col'"
      >
        <v-card class="primary darken-1 pa-0 mt-2 elevation-0">
          <strong>Informações:</strong><br />
          <div
            class="group-layers mt-6"
            v-for="(group, index) in overlaysGroup"
            :key="index"
          >
            <right-group-layer-map-menu
              :group="group"
              :locations="locations"
              :satellites="satellites"
              :visible="visible"
              @changeEnabledGroupLayer="changeEnabledGroupLayer($event)"
              @changeTimeFeature="changeTimeFeature($event)"
              @changeEnabledSublayer="changeEnabledSublayer($event)"
              @changeOpacitySublayer="changeOpacitySublayer($event)"
              @changeCurrentSatelliteState="changeCurrentSatelliteState($event)"
            ></right-group-layer-map-menu>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable */
import momentTimeZone from 'moment-timezone';
import base_layers from '@/helpers/base_layers';
import {
  getGroupLayerByProperty,
  getSubLayerByProperty,
  getVisibleBaseLayerByProperty,
  setVisibleBaseLayer,
} from '@/ol-maps/functions';
import NewBaseLayersMapMenu from '@/components/common/NewMapMenu/NewBaseLayersMapMenu';
import RightGroupLayerMapMenu from '@/components/common/NewMapMenu/RightGroupLayerMapMenu';
import LeftGroupLayerMapMenu from '@/components/common/NewMapMenu/LeftGroupLayerMapMenu';
import {Tile as TileLayer} from 'ol/layer';
export default {
  name: 'NewMapMenu',
  components: {
    LeftGroupLayerMapMenu,
    RightGroupLayerMapMenu,
    NewBaseLayersMapMenu,
  },
  props: ['basin', 'olMap', 'overlaysGroup', 'basinIcon', 'isFullscreen'],
  data() {
    return {
      dialog: false,
      items: [
        {title: 'Seletor de camadas', icon: 'layers', name: 'layers'},
        {
          title: 'Alertas de tempestade',
          icon: 'fas fa-bullseye',
          name: 'storms',
        },
      ],
      menuInformations: {
        title: 'Informações',
        icon: 'fa fa-info',
        name: 'informations',
      },
      menuItemOpened: {},
      timeFeatureSelect: {},
      attributionLayer: '',
      rightLayerGroup: [],
      visible: false,

      currentTheme: this.$route.name.toLowerCase(),
      locations: undefined,
      satellites: undefined,
    };
  },
  async mounted() {
    const visibleBaseLayer = this.getVisbleBaseLayer();
    this.attributionLayer = this.getAttributionBaseLayer(visibleBaseLayer);

    // For satellites initially..
    await this.updateMapMenuItems();

    // Updates satellites menu, if configured for the theme
    this.updateMapMenuItemsSatellites();
  },
  computed: {
    stormAlerts() {
      let storms = this.$store.getters.storms.filter(
        (alert) => alert.servico.codigo === 3,
      );

      storms = storms.map((alert) => ({
        ...alert,
        status: alert.tempestade === 0 ? 'Saindo de Alerta' : 'Em Alerta',
        observacao: alert.observacao
          ? alert.observacao
          : 'Observação não informada.',
      }));
      return storms;
    },
    baseLayers() {
      return base_layers;
    },
    basinName() {
      return this.basin?.text;
    },
    basinIconName() {
      return this.basinIcon && this.basinIcon.name
        ? this.basinIcon.name
        : 'icon-infohidro-bacia';
    },
    basinIconColor() {
      return this.basinIcon && this.basinIcon.color
        ? this.basinIcon.color
        : '#69D7A3';
    },
    themeMapMenuItems() {
      return this.$store.getters.themeMapMenuItems && this.$store.getters.themeMapMenuItems.filter(x => x.type === 'satellite_grouping_player').length > 0
        ? this.$store.getters.themeMapMenuItems.filter(x => x.type === 'satellite_grouping_player')[0] :
        'undefined';
    }
  },
  methods: {
    async updateMapMenuItems(){
      await this.$store.dispatch('loadThemeMapMenuItems', {
        from: this.currentTheme,
      });
    },
    updateMapMenuItemsSatellites() {
      if (this.themeMapMenuItems.locations && this.themeMapMenuItems.locations.length > 0) {
        this.locations = this.themeMapMenuItems.locations;
      }
      if (this.themeMapMenuItems.satellites && this.themeMapMenuItems.satellites.length > 0) {
        this.satellites = this.themeMapMenuItems.satellites;
      }
    },
    menu(value) {
      this.dialog = value;
      this.$emit('changeMenu', this.dialog);
    },
    openMiniDrawer(menuItem) {
      this.mini = !this.mini;
      if (!this.mini) {
        this.menuItemOpened = menuItem;
      }
    },
    formatStormDate(date) {
      return momentTimeZone(date)
        .tz('America/Sao_Paulo')
        .format('DD/MM/YYYY HH:mm');
    },
    getVisbleBaseLayer() {
      let baseLayerVisible = this.baseLayers['WorldTopoMap'].title;
      if (this.olMap) {
        baseLayerVisible = getVisibleBaseLayerByProperty(this.olMap, 'title');
      }
      return baseLayerVisible;
    },
    changeEnabledGroupLayer(value) {
      this.visible = value.visible;
      const layerGroup = getGroupLayerByProperty(
        this.olMap,
        'name',
        value.name,
      );
      if (layerGroup) layerGroup.setVisible(value.visible);
    },
    changeTimeFeature(timeFeature) {
      const sublayer = getSubLayerByProperty(
        this.olMap,
        'id',
        timeFeature.layerId,
      );
      if (!(sublayer instanceof TileLayer) && sublayer) {
        const source = sublayer.getSource();
        const params = source.getParams();
        source.updateParams({...params, time: timeFeature.value});
      }
      else {
        // If TileLayer
        if (sublayer.values_.id == 749) {
          const source = sublayer.getSource();
          let urlBase = source.urls[0].split("?")[0];
          let paramName = source.urls[0].split("?")[1].split("=")[0];
          const url = urlBase + "?" +paramName + "=" + timeFeature.value;
          source.setUrl(url);
        }
      }
    },
    changeEnabledSublayer(value) {
      const sublayer = getSubLayerByProperty(this.olMap, 'id', value.layerId);
      if (sublayer) {
        let radarSpan = document.getElementById('toggleRadarValue');
        let radarFunctionInterval;
        if (sublayer.get('server') === 'thredds') {
          if (sublayer.get('visible') === false) {
            radarSpan.style.visibility = 'visible';
            radarSpan.style.display = 'block';
            let updateInterval =
              sublayer.getProperties().property_params.updateInterval * 1000;
            radarFunctionInterval = window.setInterval(
              this.radarUpdateInterval,
              updateInterval,
            ); //ms
          } else {
            radarSpan.style.visibility = 'hidden';
            radarSpan.style.display = 'none';
            clearInterval(radarFunctionInterval);
          }
        }
        this.$emit('changeEnabledSublayer', {
          layerId: value.layerId,
          visible: value.visible,
        });
        sublayer.setVisible(value.visible);
      }
    },
    changeOpacitySublayer(value) {
      const sublayer = getSubLayerByProperty(this.olMap, 'id', value.layerId);
      let {opacity} = value;
      if (sublayer) {
        opacity = opacity / 100;
        sublayer.setOpacity(parseFloat(opacity));
      }
      this.$emit('changeOpacitySublayer', {
        layerId: value.layerId,
        opacity: parseFloat(opacity),
      });
    },

    changeCurrentSatelliteState(value) {
      const {
        lastVisibleLayerId,
        currentVisibleLayerId,
        bbox,
        timeFeature,
        opacity,
      } = value;
      if (lastVisibleLayerId && lastVisibleLayerId !== currentVisibleLayerId) {
        this.changeEnabledSublayer({
          layerId: lastVisibleLayerId,
          visible: false,
        });
      }
      this.changeEnabledSublayer({
        layerId: currentVisibleLayerId,
        visible: true,
      });
      this.changeOpacitySublayer({layerId: currentVisibleLayerId, opacity});
      if (timeFeature) {
        this.changeTimeFeature({
          layerId: currentVisibleLayerId,
          value: timeFeature.value,
        });
      }
      if (bbox) {
        this.$emit('changeBBOXMap', bbox);
      }
    },

    getAttributionBaseLayer(title) {
      let layer = title;
      if (title.includes('ESRI')) {
        layer = title.split('-')[1];
      }
      const {attribution} = this.baseLayers[layer];
      return attribution;
    },
    setAttributionLayer(title) {
      setVisibleBaseLayer(this.olMap, 'title', title);
      this.attributionLayer = this.getAttributionBaseLayer(title);
      this.$emit('attribution', this.attributionLayer);
    },

    radarUpdateInterval() {
      const sublayer = getSubLayerByProperty(this.olMap, 'server', 'thredds');
      if (sublayer) {
        const properties = sublayer.getProperties();
        if (
          properties.property_params &&
          properties.property_params.updateInterval
        ) {
          let source = sublayer.getSource();
          let params = source.getParams();
          params.t = new Date().getMilliseconds();
          source.updateParams(params);
          sublayer.changed();
        }
      }
    },
  },
};
</script>
<style scoped>
.v-card {
  border-left: 10px solid;
  border-right: 10px solid;
  border-top: 10px solid;
  border-bottom: 10px solid;
}
/* width */
::-webkit-scrollbar {
  width: 7px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: darkgrey;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: grey;
}

.title-map {
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
}
.select-layer-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
}
#verticalLineLeft {
  margin-top: 30px;
  height: 200px;
  border-right: 2px solid #000;
}
#verticalLineRight {
  margin-top: 30px;
  height: 200px;
  border-right: 2px solid #344355;
}

.fullscreen-first-col {
  max-height: 46vh;
  overflow-y: auto;
}

.first-col {
  height: 250px;
  overflow-y: auto;
  border-right: 2px solid #344355;
}
.fullscreen-second-col {
  border-top: 1px solid #cccccc;
  max-height: 46vh;
  overflow-y: auto;
}

.second-col {
  height: 250px;
  overflow-y: auto;
}
</style>
